import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAuthStep } from '@app/core/authentication/store/auth/auth.selectors';
import { AuthStep } from '@app/core/authentication/enums/auth-step.enum';
import { distinctUntilChanged, map, shareReplay } from 'rxjs';
import { logout } from '@app/core/authentication/store/auth/auth.actions';
import { PermissionsService } from '@app/core/permissions/services/permissions.service';
import { LeakDetectionKpiSelectionService } from '@app/main/leak-detection/services/leak-detection-kpi/leak-detection-kpi-selection.service';
import { CsrfTokenService } from '@app/core/interceptors/csrf-token-interceptor/csrf-token.service';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { ContextMenuService } from '@app/main/main-content/context-menu/services/context-menu.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private store = inject(Store);
  private permissionsService = inject(PermissionsService);
  private csrfTokenService = inject(CsrfTokenService);
  private ldKpiSelectionService = inject(LeakDetectionKpiSelectionService);
  private floatingPopupService = inject(FloatingPopupService);
  private contextMenuService = inject(ContextMenuService);

  private isUserAuthenticated$ = this.store.select(selectAuthStep).pipe(
    map(authStep => authStep === AuthStep.Authenticated),
    distinctUntilChanged(),
    // tap(authenticated => console.log('[Authenticated]:', authenticated)),
    shareReplay(1)
  );

  public isUserAuthenticated() {
    return this.isUserAuthenticated$;
  }

  public logout() {
    this.store.dispatch(logout());
    this.permissionsService.destroyUserPermissions();
    this.ldKpiSelectionService.clearSkipConfirmationFlag();
    this.csrfTokenService.clearToken();
    this.floatingPopupService.closeAll();
    this.floatingPopupService.clearAllHibernationData();
    this.contextMenuService.reset();
  }
}
